import { Component } from 'react';
import { object } from 'prop-types';
import { logger } from '@fiverr-private/obs';

class ErrorBoundary extends Component {
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error) {
        logger.error(error);
    }

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: object,
};

export default ErrorBoundary;
